//Dialog種類
export enum DialogGenre {
  Add = "登録",
  Edit = "修正",
}

export type UnyoNm = "集中型" | "分散型" | "";

export type RowId = number | string | undefined;

//存在チェックapiのパラメータ
export interface CheckExist {
  id: RowId;
  databaseField: string;
  fieldName: string;
  fieldValue: string;
}

//画面テーブルhead情報
export interface TableHeaderConfig {
  prop: string;
  label: string;
  width?: string;
  class?: string;
}
